import axios from "axios";
import React, { Fragment } from "react";
import { Dialog, Disclosure, Menu, Transition } from "@headlessui/react";
import { Link, Navigate } from "react-router-dom";
import mainLogo from "../../mglogo.png";
import { HomeIcon, MenuAlt2Icon, PlayIcon, ShoppingBagIcon, UsersIcon, XIcon, } from "@heroicons/react/outline";
import { CogIcon, ColorSwatchIcon, SearchIcon, ShoppingCartIcon, DocumentIcon, BriefcaseIcon, CashIcon } from "@heroicons/react/solid";
import { renderProgressDialog } from "../helper";
import { DataContext } from "../Context/DataContext";

let navigation = [];

const navigation_role1 = [
    {
        name: "Dashboard",
        href: "/crm/admin/dashboard",
        icon: HomeIcon,
        id: 11,
        current: false,
    },
    {
        name: "Members",
        href: "/crm/admin/member",
        icon: UsersIcon,
        id: 1,
        current: false,
    },
    {
        name: "Fees",
        href: "/crm/admin/fees",
        icon: ShoppingBagIcon,
        id: 3,
        current: false,
    },
    {
        name: "Dues",
        href: "/crm/admin/dues",
        icon: ShoppingCartIcon,
        id: 4,
        current: false,
    },
    {
        name: "Expenses",
        href: "/crm/admin/expense",
        icon: ColorSwatchIcon,
        id: 5,
        current: false,
    },
    {
        name: "Reports",
        href: "/crm/admin/report",
        icon: DocumentIcon,
        id: 7,
        current: false,
    },
    {
        name: "Create Invoice For All",
        href: "/crm/admin/Invoiceforallmembers",
        icon: CashIcon,
        id: 8,
        current: false,
    },
    {
        name: "Setting",
        current: false,
        icon: CogIcon,
        id: 6,
        children: [
            { name: "Mode of Payment", href: "/crm/admin/modeofepayment" },
            { name: "Expense Category", href: "/crm/admin/expense/categorylist" },
            { name: "Organization Profile", href: "/crm/admin/organization/profile" },
            { name: "Relationship", href: "/crm/admin/relationship/list" },
            { name: "House Number", href: "/crm/admin/housenumber/list" },
        ],
    },
];


const navigation_role3 = [

    {
        name: "List of Dues",
        href: "/crm/member/pay/list",
        icon: ShoppingCartIcon,
        id: 44,
        current: false,
    },
    {
        name: "Profile",
        href: "/crm/member/profile",
        icon: UsersIcon,
        id: 45,
        current: false,
    },
];


const userNavigation = [{ name: "Logout", href: "Login" }];

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sidebarOpen: false,
            logoutRedirect: false,
            role1: 1,
            role3: 3,
            loader_status: false,
            try_again_status: false,
            main_content_status: false,
            isLocalhost: false,

        };
    }


    setLoaderFunction = () => {

        this.setState({
            loader_status: true,
            try_again_status: false,
            main_content_status: false,
        });
    };
    closeLoaderFuncion = () => {
        this.setState({
            loader_status: false,
            try_again_status: false,
            main_content_status: true,
        });
    };

    enableTryAgain = () => {

        this.setState({
            loader_status: false,
            try_again_status: true,
            main_content_status: false,
        });
    };

    Search = (e) => {

        this.context.setSearchContent(e)

    };


    close = async (e) => {
        this.setState({ sidebarOpen: false });
    };

    open = async (e) => {
        this.setState({ sidebarOpen: true });
    };

    componentDidMount() {
        this.setState({
            isLocalhost: window.location.hostname === 'localhost',
        });
    }


    logout = async (e) => {
        e.preventDefault();
        var token = localStorage.getItem("token");

        const res = await axios.get("api/logout", {
            headers: {
                authorization: `Bearer ${token}`,
                Accept: "application/json",
            },
        });
        if (res.data.success) {

            localStorage.removeItem("role");
            localStorage.removeItem("role");
            localStorage.removeItem("role_id");
            this.setState({ logoutRedirect: true });
        }
    };

    static contextType = DataContext;

    render() {

        const baseUrl = this.state.isLocalhost
            ? 'http://localhost:3000/crm/'
            : 'https://arwa.dreamstech.biz/crm/';


        let token = localStorage.getItem("token");
        const { searchUi } = this.context;
        if (token == null) {
            return <Navigate to={"/Login"} />;
        }

        if (this.state.role1 == localStorage.getItem("role_id")) {

            navigation = navigation_role1;

            if (this.props.navId) {

                navigation = navigation.map(item => ({
                    ...item,
                    current: item.id === this.props.navId,
                }));
            }
        }

        if (this.state.role3 == localStorage.getItem("role_id")) {

            navigation = navigation_role3;

            if (this.props.navId) {

                navigation = navigation.map(item => ({
                    ...item,
                    current: item.id === this.props.navId,
                }));
            }
        }

        if (this.state.logoutRedirect) {
            this.state.logoutRedirect = false;
            this.setState({ logoutRedirect: this.state.logoutRedirect });
            return <Navigate to={"/Login"} />;
        }


        return (
            <>

                <Transition.Root show={this.state.sidebarOpen} as={Fragment}>
                    <Dialog
                        as="div"
                        className="fixed inset-0 flex z-40 md:hidden"
                        onClose={this.close}
                    >
                        <Transition.Child
                            as={Fragment}
                            enter="transition-opacity ease-linear duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="transition-opacity ease-linear duration-300"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
                        </Transition.Child>
                        <Transition.Child
                            as={Fragment}
                            enter="transition ease-in-out duration-300 transform"
                            enterFrom="-translate-x-full"
                            enterTo="translate-x-0"
                            leave="transition ease-in-out duration-300 transform"
                            leaveFrom="translate-x-0"
                            leaveTo="-translate-x-full"
                        >
                            <div className="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-in-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in-out duration-300"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <div className="absolute top-0 right-0 -mr-12 pt-2">
                                        <button
                                            type="button"
                                            className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                            onClick={() => this.close()}
                                        >
                                            <span className="sr-only">Close sidebar</span>
                                            <XIcon
                                                className="h-6 w-6 text-white"
                                                aria-hidden="true"
                                            />
                                        </button>
                                    </div>
                                </Transition.Child>
                                <div className="flex-shrink-0 flex items-center px-4">
                                    <img className="h-8 w-auto" src={mainLogo} alt="Workflow" />
                                </div>
                                <div className="mt-5 flex-1 h-0 overflow-y-auto">
                                    <nav
                                        className="flex-1 px-2 space-y-1 bg-white"
                                        aria-label="Sidebar"
                                    >

                                        {navigation.map((item) =>
                                            !item.children ? (
                                                <div key={item.name}>
                                                    <a
                                                        href={item.href}
                                                        className={classNames(
                                                            item.current
                                                                ? "bg-gray-100 text-gray-900"
                                                                : "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                                                            "group w-full flex items-center pl-2 py-2 text-sm font-medium rounded-md"
                                                        )}
                                                    >
                                                        <item.icon
                                                            className={classNames(
                                                                item.current
                                                                    ? "text-gray-500"
                                                                    : "text-gray-400 group-hover:text-gray-500",
                                                                "mr-3 flex-shrink-0 h-6 w-6"
                                                            )}
                                                            aria-hidden="true"
                                                        />
                                                        {item.name}
                                                    </a>
                                                </div>
                                            ) : (
                                                <Disclosure
                                                    as="div"
                                                    key={item.name}
                                                    className="space-y-1"
                                                >
                                                    {({ open }) => (
                                                        <>
                                                            <Disclosure.Button
                                                                className={classNames(
                                                                    item.current
                                                                        ? "bg-gray-100 text-gray-900"
                                                                        : "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                                                                    "group w-full flex items-center pl-2 pr-1 py-2 text-left text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                                )}
                                                            >
                                                                <item.icon
                                                                    className="mr-3 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                                                    aria-hidden="true"
                                                                />
                                                                <span className="flex-1">{item.name}</span>
                                                                <svg
                                                                    className={classNames(
                                                                        open
                                                                            ? "text-gray-400 rotate-90"
                                                                            : "text-gray-300",
                                                                        "ml-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150"
                                                                    )}
                                                                    viewBox="0 0 20 20"
                                                                    aria-hidden="true"
                                                                >
                                                                    <path
                                                                        d="M6 6L14 10L6 14V6Z"
                                                                        fill="currentColor"
                                                                    />
                                                                </svg>
                                                            </Disclosure.Button>
                                                            <Disclosure.Panel className="space-y-1">
                                                                {item.children.map((subItem) => (
                                                                    <Disclosure.Button
                                                                        key={subItem.name}
                                                                        as="a"
                                                                        href={subItem.href}
                                                                        className="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50"
                                                                    >
                                                                        {subItem.name}
                                                                    </Disclosure.Button>
                                                                ))}
                                                            </Disclosure.Panel>
                                                        </>
                                                    )}
                                                </Disclosure>
                                            )
                                        )}


                                    </nav>
                                    <div className="flex flex-shrink-0 border-t border-gray-200 p-4">
                                        <a href="#" className="group block w-full flex-shrink-0">
                                            <div className="flex items-center">
                                                <div className="ml-3">
                                                    <p className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                                                        @ Dreams
                                                    </p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Transition.Child>
                        <div className="flex-shrink-0 w-14" aria-hidden="true">
                            {/* Dummy element to force sidebar to shrink to fit close icon */}
                        </div>
                    </Dialog>
                </Transition.Root>

                {/* Static sidebar for desktop */}
                <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
                    {/* Sidebar component, swap this element with another sidebar if you like */}
                    <div className="flex flex-col flex-grow border-r border-gray-200 pt-5 bg-white overflow-y-auto">
                        <div className="flex items-center flex-shrink-0 px-4">
                            <a href="#">
                                <img className="w-auto" src={mainLogo} alt="Workflow" />
                            </a>
                        </div>


                        <div className="mt-5 flex-grow flex flex-col">
                            <nav
                                className="flex-1 px-2 space-y-1 bg-white"
                                aria-label="Sidebar"
                            >
                                {navigation.map((item) =>
                                    !item.children ? (
                                        <div key={item.name}>
                                            <a
                                                href={item.href}
                                                className={classNames(
                                                    item.current
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                                                    "group w-full flex items-center pl-2 py-2 text-sm font-medium rounded-md"
                                                )}
                                            >
                                                <item.icon
                                                    className={classNames(
                                                        item.current
                                                            ? "text-gray-500"
                                                            : "text-gray-400 group-hover:text-gray-500",
                                                        "mr-3 flex-shrink-0 h-6 w-6"
                                                    )}
                                                    aria-hidden="true"
                                                />
                                                {item.name}
                                            </a>
                                        </div>
                                    ) : (
                                        <Disclosure
                                            as="div"
                                            key={item.name}
                                            className="space-y-1"
                                        >
                                            {({ open }) => (
                                                <>
                                                    <Disclosure.Button
                                                        className={classNames(
                                                            item.current
                                                                ? "bg-gray-100 text-gray-900"
                                                                : "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                                                            "group w-full flex items-center pl-2 pr-1 py-2 text-left text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 "
                                                        )}
                                                    >
                                                        <item.icon
                                                            className="mr-3 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                                            aria-hidden="true"
                                                        />
                                                        <span className="flex-1">{item.name}</span>
                                                        <svg
                                                            className={classNames(
                                                                open
                                                                    ? "text-gray-400 rotate-90"
                                                                    : "text-gray-300",
                                                                "ml-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150"
                                                            )}
                                                            viewBox="0 0 20 20"
                                                            aria-hidden="true"
                                                        >
                                                            <path
                                                                d="M6 6L14 10L6 14V6Z"
                                                                fill="currentColor"
                                                            />
                                                        </svg>
                                                    </Disclosure.Button>
                                                    <Disclosure.Panel className="space-y-1">
                                                        {item.children.map((subItem) => (
                                                            <Disclosure.Button
                                                                key={subItem.name}
                                                                as="a"
                                                                href={subItem.href}
                                                                className="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50"
                                                            >
                                                                {subItem.name}
                                                            </Disclosure.Button>
                                                        ))}
                                                    </Disclosure.Panel>
                                                </>
                                            )}
                                        </Disclosure>
                                    )
                                )}
                            </nav>

                        </div>
                    </div>
                </div>
                <div className="md:pl-64 flex flex-col flex-1 ">
                    <div className="sticky top-0 z-10 flex-shrink-0 flex h-16 bg-white shadow">
                        <button
                            type="button"
                            className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
                            onClick={() => this.open()}
                        >
                            <span className="sr-only">Open sidebar</span>
                            <MenuAlt2Icon className="h-6 w-6" aria-hidden="true" />
                        </button>
                        <div className="flex-1 px-4 flex justify-end">
                            {searchUi && (
                                <div className="flex-1 flex">
                                    <form className="w-full flex md:ml-0" action="#" method="GET">
                                        <label htmlFor="search-field" className="sr-only">
                                            Search
                                        </label>
                                        <div className="relative w-full text-gray-400 focus-within:text-gray-600">
                                            <div
                                                className="absolute inset-y-0 left-0 flex items-center pointer-events-none">
                                                <SearchIcon className="h-5 w-5" aria-hidden="true" />
                                            </div>
                                            <input
                                                id="search-field"
                                                className="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm"
                                                placeholder="Search"
                                                onChange={this.Search}
                                                type="search"
                                                name="search"
                                            />
                                        </div>
                                    </form>
                                </div>
                            )}

                            <div className="ml-4 flex items-center md:ml-6">
                                {/* Profile dropdown */}
                                <Menu as="div" className="ml-3 relative">
                                    <div>
                                        <Menu.Button
                                            className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            <span className="sr-only">Open user menu</span>
                                            <span
                                                className="inline-block h-6 w-6 overflow-hidden rounded-full bg-gray-100">
                                                <svg
                                                    className="h-full w-full text-gray-300"
                                                    fill="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                                                </svg>
                                            </span>
                                        </Menu.Button>
                                    </div>
                                    <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                    >
                                        <Menu.Items
                                            className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            {userNavigation.map((item) => (
                                                <Menu.Item key={item.name}>
                                                    {({ active }) => (
                                                        <Link
                                                            to={"#"}
                                                            onClick={this.logout}
                                                            className={classNames(
                                                                active ? "bg-gray-100" : "",
                                                                "block px-4 py-2 text-sm text-gray-700"
                                                            )}
                                                        >
                                                            {item.name}
                                                        </Link>
                                                    )}
                                                </Menu.Item>
                                            ))}
                                        </Menu.Items>
                                    </Transition>
                                </Menu>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col min-h-screen">
                        <main className="flex-1">
                            <div className="py-6">
                                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                                    {/* Replace with your content */}
                                    {this.props.childrenPage}
                                    {/* /End replace */}
                                </div>
                            </div>
                        </main>
                        <footer className="bg-white border border-gray-300 text-black p-4 md:block w-full">
                            <div className="container mx-auto">
                                <a href="https://dreamstech.co" target="_blank" className="text-gray-600 hover:text-blue-500">&copy; 2024 Dreams. All rights reserved.</a>
                                <div className="mt-4 flex flex-wrap justify-center">
                                    <a href={`${baseUrl}contact/us`} target="_blank" className="text-black hover:text-blue-500 mr-4 mb-2 md:mb-0">Contact Us</a>
                                    <a href={`${baseUrl}terms/conditions`} target="_blank" className="text-black hover:text-blue-500 mr-4 mb-2 md:mb-0">Terms & Conditions</a>
                                    <a href={`${baseUrl}privacy/policy`} target="_blank" className="text-black hover:text-blue-500 mr-4 mb-2 md:mb-0">Privacy Policy</a>
                                    <a href={`${baseUrl}refund/cancellation/policy`} target="_blank" className="text-black hover:text-blue-500 mr-4 mb-2 md:mb-0">Refund & Cancellation Policy</a>
                                    <a href={`${baseUrl}shipping/delivery/policy`} target="_blank" className="text-black hover:text-blue-500 mr-4 mb-2 md:mb-0">Shipping & Delivery Policy</a>
                                    <a href={`${baseUrl}order/summary/checkout`} target="_blank" className="text-black hover:text-blue-500 mr-4 mb-2 md:mb-0">Checkout</a>
                                </div>
                            </div>
                        </footer>
                    </div>
                </div>

            </>
        );
    }
}

export default Navbar;
